const height = '60vh';
const width = '100%';

export const routerStyle = {
    position: "absolute",
    textAlign: "right",
    width,
    height,
    marginTop: '1em'
}

export const mapStyle = {
    overflow: "hidden",
    background: 'none',
    height,
    width
}

export const iframeStyle = {
    width,
    height
}